/* Capability registry — byte-compatible mirror of
 * api/src/model/capabilities.ts. Each capability gates one or more nav
 * sections (and their config routes) in the app. */

export interface Capability {
  id: string;
  label: string;
  description: string;
  /** true for capabilities that unlock configuration/admin surfaces */
  admin?: boolean;
}

export const CAPABILITIES: Capability[] = [
  { id: "customers", label: "Customers", description: "Accounts, relationships, and success plans." },
  { id: "insights", label: "Signals & Insights", description: "Signals, predictions, risk agents, and dashboards." },
  { id: "team_analytics", label: "Team Analytics", description: "CSM scorecards and team-level performance." },
  { id: "execution", label: "Execution", description: "Tasks, playbooks, and automations." },
  { id: "revenue", label: "Revenue & Voice", description: "Renewals, surveys, and QBR builder." },
  { id: "settings", label: "Configuration", description: "Health model, task types, segments, and delivery settings.", admin: true },
  { id: "integrations", label: "Integrations", description: "Connectors, data studio, and CSV import.", admin: true },
  { id: "developers", label: "Developers", description: "API keys, webhooks, and developer tools.", admin: true },
  { id: "governance", label: "Governance", description: "Roles, permission groups, and access control.", admin: true },
];

export const CAPABILITY_IDS: Set<string> = new Set(CAPABILITIES.map((c) => c.id));

/** Resolve the capability set a user has via their permission group. */
export function capabilitiesFor(
  user: { groupId?: string } | undefined,
  groups: { id: string; capabilities: string[] }[],
): Set<string> {
  const g = groups.find((x) => x.id === user?.groupId);
  return new Set(g?.capabilities ?? []);
}
